export default __webpack_public_path__ + "static/background-e6b819eac036bac39f4f4d293c0ee2ac.jpg";